<template>
  <div class="document-mobile">
    <Header :onShow="()=>drawer=true" />

    <div class="content" v-html="content"></div>
    <Drawer
      title="文档列表"
      :with-header="true"
      :visible.sync="drawer"
      direction="ltr"
      :before-close="()=>(drawer=false)"
      size="70%"
    >
      <Collapse v-model="activeNames">
        <div class="box" v-for="(cat,i) in category" :key="i">
          <CollapseItem :name="i.toString()">
            <template slot="title">
              <CtrCat :item="cat" :disabled="true" />
            </template>
            <ArtLst :articles="cat.articles" :disabled="true" :onClick="onLink" />
            <div class="box" v-for="(sub,j) in cat.sub" :key="j">
              <CollapseItem :name="`${i}.${j}`">
                <template slot="title">
                  <CtrCat :item="sub" :disabled="true" />
                </template>
                <ArtLst :articles="sub.articles" :disabled="true" :onClick="onLink" />
                <div class="box" v-for="(sub1,k) in sub.sub" :key="k">
                  <CollapseItem :name="`${i}.${j}.${k}`">
                    <template slot="title">
                      <CtrCat :item="sub1" :disabled="true" />
                    </template>
                    <ArtLst :articles="sub1.articles" :disabled="true" :onClick="onLink" />
                    <div class="box" v-for="(sub2,l) in sub1.sub" :key="l">
                      <CollapseItem :name="`${i}.${j}.${k}.${l}`">
                        <template slot="title">
                          <CtrCat :item="sub2" :disabled="true" />
                        </template>
                        <ArtLst :articles="sub2.articles" :disabled="true" :onClick="onLink" />
                      </CollapseItem>
                    </div>
                  </CollapseItem>
                </div>
              </CollapseItem>
            </div>
          </CollapseItem>
        </div>
      </Collapse>
    </Drawer>
  </div>
</template>

<script>
import Header from '@/components/header'
import { Drawer, Collapse, CollapseItem } from 'element-ui'
import { getCategory, getArticle } from '@/utils/service'
import CtrCat from '../components/control_category'
import ArtLst from '../components/article_lists'

export default {
  name: 'document-mobile',
  components: { Header, Drawer, Collapse, CollapseItem, CtrCat, ArtLst },
  data() {
    return {
      drawer: false,
      activeNames: ['0'],
      category: [],
      path: '',
      content: '',
    }
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      this.getArt(to.params.id)
    },
  },
  async mounted() {
    if (this.$route.params.id) this.getArt(this.$route.params.id)

    if (this.$route.params.type) {
      // 获取当前目录的子目录
      try {
        const response = await getCategory({ sid: this.$route.params.type })
        if (response.status) {
          this.category = response.data
        } else {
          this.category = []
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  methods: {
    async getArt(id) {
      let response = await getArticle({ id })
      if (response.status) {
        this.content = response.data[0].content
      } else {
        this.content = ''
      }
    },
    onLink() {
      this.drawer = false
    },
  },
}
</script>

<style lang="less" >
@import './index.less';
</style>
